@if (showBrandLoaderHeader) {
    <div class="banner">
        @for (_ of [].constructor(3); track _) {
            <img src="https://assets.box8.co.in/missing/eatclub.png" />
        }
    </div>

    <div class="popular-header">
        <div class="shine"></div>
    </div>
    <div style="padding: 16px">
        <div class="brands">
            @for (_ of [].constructor(4); track _) {
                <div class="shine"></div>
            }
        </div>
    </div>
} @else {
    <div>
        <img class="brand-loader" src="https://assets.box8.co.in/missing/eatclub.png" />
    </div>
    <div class="container home-page-banners">
        <div class="shine heading"></div>
        <div class="whats-banner">
            @for (_ of [].constructor(6); track _) {
                <div>
                    <img src="https://assets.box8.co.in/missing/eatclub.png" />
                </div>
            }
        </div>

        <div class="popular-header">
            <div class="shine"></div>
        </div>

        <div class="shine heading"></div>
        <div class="whats-banner">
            @for (_ of [].constructor(6); track _) {
                <div>
                    <img class="round" src="https://assets.box8.co.in/missing/eatclub.png" />
                </div>
            }
        </div>
    </div>
}
